export default {
    'application.email' : {
        'profileSync': {
            'toProfile' : {
                'enable': true,
                'overwrite': true,
            },
            'fromProfile' : {
                'enable': true,
                'overwrite': false,
            },
            'profilePath': 'email',
        },
    },
    'application.phone' : {
        'profileSync': {
            'toProfile' : {
                'enable': true,
                'overwrite': true,
            },
            'fromProfile' : {
                'enable': true,
                'overwrite': false,
            },
            'profilePath': 'phone',
        },
    },
    'application.occupant': {
        'model': 'Contact',
        'profileSync': {
            'toProfile' : {
                'enable': true,
                'overwrite': true,
                'properties': [ 'firstName', 'lastName' ],
            },
            'fromProfile' : {
                'enable': true,
                'overwrite': false,
                'properties': [ 'firstName', 'lastName' ],
            },
            'profilePath': '$',
        },
    },
};
